export default {"src":"/_next/static/media/PFE.3f00d8a7.svg","height":18,"width":18};